import * as React from "react";
import { SVGProps } from "react";
export const ChevronLineLeftIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.209 17.458L8.271 10.521C8.17433 10.4237 8.105 10.323 8.063 10.219C8.021 10.115 8 10.0073 8 9.896C8 9.78467 8.021 9.677 8.063 9.573C8.105 9.469 8.17433 9.36833 8.271 9.271L15.23 2.313C15.438 2.10433 15.6913 2 15.99 2C16.2887 2 16.542 2.11133 16.75 2.334C16.9727 2.542 17.077 2.79867 17.063 3.104C17.049 3.41 16.938 3.667 16.73 3.875L10.709 9.896L16.75 15.938C16.9447 16.132 17.042 16.3853 17.042 16.698C17.042 17.0107 16.9447 17.264 16.75 17.458C16.542 17.6667 16.2853 17.771 15.98 17.771C15.674 17.771 15.417 17.6667 15.209 17.458Z"
            fill="currentColor"
        />
        <path
            d="M5 16.7999C5 17.1236 4.90095 17.4048 4.70286 17.6434C4.504 17.8811 4.26971 18 4 18C3.73029 18 3.49638 17.8811 3.29829 17.6434C3.09943 17.4048 3 17.1236 3 16.7999L3 3.20007C3 2.87639 3.09943 2.59523 3.29829 2.35659C3.49638 2.11886 3.73029 2 4 2C4.26971 2 4.504 2.11886 4.70286 2.35659C4.90095 2.59523 5 2.87639 5 3.20007L5 16.7999Z"
            fill="currentColor"
        />
    </svg>
);
ChevronLineLeftIcon.displayName = "ChevronLineLeftIcon";
